import { render, staticRenderFns } from "./openstreetmap.vue?vue&type=template&id=4ec2a3fc&"
import script from "./openstreetmap.vue?vue&type=script&lang=js&"
export * from "./openstreetmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ec2a3fc')) {
      api.createRecord('4ec2a3fc', component.options)
    } else {
      api.reload('4ec2a3fc', component.options)
    }
    module.hot.accept("./openstreetmap.vue?vue&type=template&id=4ec2a3fc&", function () {
      api.rerender('4ec2a3fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Hgd6SS4GrFt2/JS/comp/openstreetmap.vue"
export default component.exports